// Ported from dev-scrips-pm-react src/billing/pages/invoice-detail-page.tsx (PROD-3312 appointment Billing tab): the
// header chip mappings and the Issue hint, in their own module so the page file exports components only.
import type { StatusChipProps } from '@/billing/bridge';

type StatusSemantic = NonNullable<StatusChipProps['semantic']>;

/** Invoice status -> chip semantic (anything else is neutral). */
export const STATUS_BADGE_SEMANTIC: Readonly<Record<string, StatusSemantic>> = {
  Issued: 'info',
  Draft: 'neutral',
  Cancelled: 'error',
  Submitted: 'success',
};

/** Patient payment status -> chip semantic (anything else is neutral). */
export const PAYMENT_BADGE_SEMANTIC: Readonly<Record<string, StatusSemantic>> = {
  'Not Paid': 'error',
  Paid: 'success',
  'Partially Paid': 'warning',
  'Fully Rejected': 'error',
};

/** Under a disabled Issue Invoice while an order line that left the plan waits for Keep or Drop. */
export const ISSUE_BLOCKED_HINT = 'Keep or drop the removed order line to issue';
